import laughEmoji from "../assets/people-of-lentera/laugh-emoji.svg";
import starEmoji from "../assets/people-of-lentera/star-emoji.svg";
import paperPlane from "../assets/people-of-lentera/paper-plane.svg";
import contactStrip from "../assets/people-of-lentera/strip-images.webp";
import peopleImage from "../assets/people-of-lentera/people-lentera.webp";
import yellowDot from "../assets/people-of-lentera/decor-yellow-dott.svg";
import pinkTriangle from "../assets/people-of-lentera/decor-pink-trianglee.svg";
import underline from "../assets/underlinea.png";

// profile card
import ProfileCard from "./people-of-lentera/ProfileCard";

// specialists section
import SpecialistsSection from "./people-of-lentera/SpecialistsSection";

// static json data for specialists & teams
import teams from "../data/people-of-lentera/teams.json";
import specialists from "../data/people-of-lentera/specialists.json";

const PeopleSection = () => {
  const row1 = specialists.slice(0, 5);
  const row2 = specialists.slice(5, 10);

  return (
    <>
      <section className="w-full bg-[#fdf6dc] pb-8 lg:pb-16">
        {/* Header */}
        <div className="text-center px-4 pt-8 lg:pt-16">
          <h2 className="text-3xl sm:text-[48px] text-[#1E1E1E] leading-tight">
            People of Lentera
          </h2>
          <img
            src={underline}
            alt="underline"
            className="mx-auto mt-2 w-[80px] h-[2px]"
          />

          <p className="mt-6 md:text-sm sm:text-lg text-[#3A3A3A] max-w-[450px] mx-auto leading-relaxed">
            A behind-the-scenes look at the people who shaped our craft—
            building the foundation of our culture and the products we proudly
            create today.
          </p>
        </div>

        <div className="max-w-7xl mx-auto mt-8 lg:mt-16 flex justify-center">
          <div
            className="
              inline-grid
              mx-auto
              grid-cols-1
              sm:grid-cols-2
              lg:grid-cols-3
              gap-6
              xl:gap-x-12
              md:gap-y-32
              place-items-center 
            "
          >
            {teams.map((item, index) => (
              <ProfileCard key={index} specialist={item} />
            ))}
          </div>
        </div>
      </section>

      <SpecialistsSection row1={row1} row2={row2} />

      <section className="w-full bg-white py-8 lg:py-16 px-4 lg:px-8 xl:px-16">
        <div className="max-w-[1920px] mx-auto flex flex-col md:flex-row items-center gap-6 lg:gap-[4%] relative">
          {/* Left Side (40%) */}
          <div className="w-full md:w-[38%] tetx-[#212129]">
            {/* Heading and Content */}
            <div className="mt-10 lg:mt-0">
              <h2 className="relative inline-block text-2xl md:text-3xl lg:text-5xl font-regular leading-tight mb-6 xl:mb-12">
                <img
                  src={laughEmoji}
                  alt="Laugh Emoji"
                  className="absolute -top-8 -left-2 lg:-top-12 lg:-left-6 w-8 h-8 lg:w-12 lg:h-12"
                />
                {/* Emoji Star - Floating above right side of heading */}
                <img
                  src={starEmoji}
                  alt="Star Emoji"
                  className="absolute -top-12 -right-[5%] w-10 h-10 lg:w-16 lg:h-16"
                />
                Passionate work, <br />
                playful connections
              </h2>

              {/* Green underline */}
              <div className="w-20 border border-[#07862B] mb-6 lg:mb-12" />

              {/* Description */}
              <p className="text-sm md:text-base font-regular leading-normal mb-0">
                At Lentera Technologies, we empower like-minded individuals with
                the freedom to thrive. With the right tools and support, your
                growth becomes our shared success.
              </p>
            </div>
            {/* Paper plane */}
            <img src={paperPlane} alt="Paper Plane" className="-ml-6" />
          </div>

          {/* Right Side (60%) - Scrolling Strip */}
          <div className="relative w-full md:w-[58%] h-[505px] overflow-hidden">
            {/* Blur overlays */}
            <div className="absolute top-0 left-0 w-4 md:w-10 xl:w-20 h-full z-10 bg-gradient-to-r from-white via-white/80 to-transparent pointer-events-none" />
            <div className="absolute top-0 right-0 w-4 md:w-10 xl:w-20 h-full z-10 bg-gradient-to-l from-white via-white/80 to-transparent pointer-events-none" />

            {/* Scrolling strip */}
            <div className="flex w-max animate-scroll-seamless whitespace-nowrap overflow-hidden">
              {[...Array(4)].map((_, i) => (
                <img
                  key={i}
                  src={contactStrip}
                  alt={`contact-strip-${i}`}
                  className="h-[505px] w-[768px] object-cover shrink-0"
                />
              ))}
            </div>

            {/* Scroll Animation */}
            <style>{`
            @keyframes scroll-seamless {
              0% {
                transform: translateX(0%);
              }
              100% {
                transform: translateX(-50%);
              }
            }
            .animate-scroll-seamless {
              animation: scroll-seamless 20s linear infinite;
            }
          `}</style>
          </div>
        </div>
      </section>

      <section className="w-full bg-white relative overflow-hidden">
        {/* Top Team Image */}
        <img
          src={peopleImage}
          alt="People of Lentera"
          className="w-full object-cover h-auto max-w-[1920px] mx-auto"
        />

        {/* Content Card */}
        <div className="w-full flex justify-center -mt-4 md:-mt-12 lg:-mt-24 xl:-mt-[120px] px-4 relative z-10">
          <div className="bg-white w-full max-w-[1312px] px-6 md:px-16 lg:px-20 py-[56px] flex flex-col md:flex-row items-start justify-between relative">
            {/* Yellow Dot */}
            <img
              src={yellowDot}
              alt="Yellow Dot"
              className="absolute top-0 left-0 w-14 lg:w-18 h-auto"
            />

            {/* Pink Triangle */}
            <img
              src={pinkTriangle}
              alt="Pink Triangle"
              className="absolute right-0 bottom-0 w-20 lg:w-[125px] h-auto"
            />

            {/* Paper Plane */}
            <img
              src={paperPlane}
              alt="Paper Plane"
              className="absolute hidden md:block left-[10%] xl:left-[25%] bottom-[-10px] w-[200px] md:w-[300px] h-auto"
            />

            {/* Left Side */}
            <div className="w-full max-w-[340px] mb-8 md:mb-0">
              <h2 className="text-2xl md:text-3xl lg:text-5xl leading-tight font-regular text-transparent bg-clip-text bg-gradient-to-r from-[#7B41E6] to-[#EF3BF2]">
                6+ years
              </h2>
              <p className="text-base md:text-[20px] leading-normal text-[#212129] font-medium mt-2">
                of running a business has taught us many things
              </p>
            </div>

            {/* Right Side: Quote */}
            <div className="w-full max-w-[540px]">
              <div className="md:border-l-[2px] border-[#07862B] md:pl-6 italic text-[16px] md:text-[18px] text-[#333] leading-[28px] md:leading-[30px]">
                “We believe that investing in our people leads to long-term
                commitment. We're proud and humbled that many of our colleagues
                have been with us for over a decade, growing alongside the
                company.”
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PeopleSection;
